exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".desktop{width:100%;height:100%;background-image:url(" + require("../../resources/logocore.png") + ");background-repeat:no-repeat;background-position:50%;background-position-y:30%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./app/views/dashboard/dashboard.css
// module id = 232
// module chunks = 0